'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var SectionEmployment = React.createClass({

  componentDidMount() {
    this.props.logPageView();
  },

  /**
   * @return {object}
   */
  render: function () {
    let urlCorporate = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/6b0b77e0-7f45-4b35-9c08-7a1d7fa0a620/?q=&o=postedDateDesc';
    let urlAbilene = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/3c6d40e9-0687-408c-9d6b-98def83f46d3/?q=&o=postedDateDesc';
    let urlAustin = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/5fee0e3e-905a-48dc-9dd5-cd368d377492/?q=&o=postedDateDesc';
    let urlCalifornia = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/50952ce2-ac91-48c8-9736-1af2b0d41848/?q=&o=postedDateDesc';
    let urlDallas = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/9d2ac99c-fc33-4150-b9d4-011b59c870f2/?q=&o=postedDateDesc';
    let urlElValle = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/36273d9e-df05-4a39-b80d-5966dd36dd12/?q=&o=postedDateDesc';
    let urlGeorgia = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/efa239b0-1d76-44d6-8069-4e1b86cd3cdb/?q=&o=postedDateDesc';
    let urlHouston = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/e11ac101-e8ce-412c-bd73-536c9b894a01/?q=&o=postedDateDesc';
    let urlHoustonCorp = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/6b0b77e0-7f45-4b35-9c08-7a1d7fa0a620/?q=&o=postedDateDesc';
    let urlLouisiana = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/5ba74581-1243-47b8-9a11-2de536e5b007/?q=&o=postedDateDesc';
    let urlLufkin = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/574da538-50a0-4639-8535-786ecab0b835/?q=&o=postedDateDesc';
    let urlMississipi = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/ebbd5d9d-571a-47c3-a035-500e41e280e3/?q=&o=postedDateDesc';
    let ulrNewJersey = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/40e898a3-40c7-4e3c-8694-8e8135b03ae6/?q=&o=postedDateDesc';
    let urlOhio = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/5e7b66c4-5488-4de3-83c9-03c607503136/?q=&o=postedDateDesc';
    let urlOklahoma = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/26d93d0d-140f-4770-8b23-159e8bc5fa5e/?q=&o=postedDateDesc';
    let urlSanAntonio = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/ecc72350-6cd9-453f-954c-d07bf77d016e/?q=&o=postedDateDesc';
    let urlUtah = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/7b919d2a-e3d7-477c-a6eb-1ce54948e3aa/?q=&o=postedDateDesc';
    let urlWaco = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/959e21db-2210-47e6-a20e-7df7b1eea922/?q=&o=postedDateDesc';
    let urlWashington = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/223cafe1-badd-464c-9595-5c1af954b9b9/?q=&o=postedDateDesc';




    let urlAustinWaco = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/5fee0e3e-905a-48dc-9dd5-cd368d377492/?q=&o=postedDateDesc';
    let urlDallasSurrender = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/9d2ac99c-fc33-4150-b9d4-011b59c870f2/?q=&o=postedDateDesc';
    let urlElValleSurrender = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/36273d9e-df05-4a39-b80d-5966dd36dd12/?q=&o=postedDateDesc';
    let urlHoustonSurrender = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/e11ac101-e8ce-412c-bd73-536c9b894a01/?q=&o=postedDateDesc'
    let urlLufkinNacog = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/574da538-50a0-4639-8535-786ecab0b835/?q=&o=postedDateDesc';

    let urlAlabama = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/d430cf08-adc5-4bc6-88cb-b6f7bf80fa7b/?q=&o=postedDateDesc';
    let urlArizona = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/aef32937-bad2-423b-9d27-5de2dd23fd2b/?q=&o=postedDateDesc'
    let urlArkansas = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/197c2e5a-386e-4d15-b728-0bf4cc04e0dd/?q=&o=postedDateDesc';
    let urlColorado = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/27c2d993-543e-4e25-b6ee-77a4af4c4bb1/?q=&o=postedDateDesc'
    let urlConnecticut = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/f3895673-746c-4bff-bf25-80eadf3bf45f/?q=&o=postedDateDesc'
    let urlFlorida = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/f3349383-d2c0-4c25-8015-2477e8efb199/?q=&o=postedDateDesc'
    let urlIllinois = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/60ebebd8-ef52-443d-9046-e9904500b42f/?q=&o=postedDateDesc'
    let urlMassachussets = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/d73ed12c-f1b9-4b2b-bf1e-740e2da8831d/?q=&o=postedDateDesc'
    let urlMinnesotaIowaSouthDakota = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/ec079be3-b383-4f52-a838-00dc63ec9d7d/?q=&o=postedDateDesc'
    let urlNevada = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/1947a192-afea-42a6-831b-54bcdc8308e9/?q=&o=postedDateDesc'
    let urlNewYork = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/bdf2e5d3-cfcb-4bec-84b2-26bc3e819bd1/?q=&o=postedDateDesc'
    let urlNorthCarolina = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/5456f600-c1b1-4eb7-bf99-3985d7f56e9f/?q=&o=postedDateDesc'
    let urlPennsylvania = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/0c7706a2-97ea-4ae7-8b56-27d6ea12eb3d/?q=&o=postedDateDesc'
    let ulrRhodeIsland = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/ec30293e-47a2-48cd-9fe3-44961adea55e/?q=&o=postedDateDesc'
    let urlSouthCarolina = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/7fe9bce4-3659-4061-b46d-5dfbb55facf1/?q=&o=postedDateDesc'
    let urlPuertoRico = 'https://recruiting2.ultipro.com/BAR1025BFG/JobBoard/65b96b06-93cb-47b5-a574-99e57a87d828/?q=&o=postedDateDesc'

    return (
      <section id="section5" className="content-section text-center about-section sectionPage">
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
            <div className="title-v1">
              <div className="row">
                <div className="col-sm-12   col-xs-12">
                  <h1 className="text-center"><FormatMessage locale={this.props.locale}
                    path="employmentPage/employmentTitle" />
                  </h1>
                  <hr className="small" />
                </div>
                <div className="col-sm-8 col-xs-8 col-xs-offset-2">
                  <p><FormatMessage locale={this.props.locale}
                    path="employmentPage/employmentDescription1" /></p>
                </div>

              </div>
            </div>
          </div>
          <div style={{ marginTop: 10 }} className="col-sm-6 col-xs-12 col-md-3">
            <a style={{ fontSize: 'medium' }} target="_blank" href={urlCorporate}>
              <h4>
                <FormatMessage locale={this.props.locale} path="employmentPage/corporateCarrers" />
              </h4>
            </a> &nbsp;&nbsp;&nbsp;
          </div>
          <div style={{ marginTop: 10 }} className="col-sm-6 col-xs-12 col-md-3">
            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlAbilene}>Abilene - Texas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlAustinWaco}>Austin/Waco – Texas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlDallasSurrender}>Dallas - Texas & Surrounding Areas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlElValleSurrender}>El Valle – Texas & Surrounding Areas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlHoustonSurrender}>Houston – Texas & Surrounding Areas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlLufkinNacog}>Lufkin/Longview/Nacogdoches- Texas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlSanAntonio}>San Antonio - Texas</a> &nbsp;&nbsp;&nbsp;
            </div>
          </div>
          <div style={{ marginTop: 10 }} className="col-sm-6 col-xs-12 col-md-3">
            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlAlabama}>Alabama</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlArizona}>Arizona </a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlArkansas}>Arkansas</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlCalifornia}>California</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlColorado}>Colorado</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlConnecticut}>Connecticut</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlFlorida}>Florida</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlGeorgia}>Georgia</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlIllinois}>Illinois</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlLouisiana}>Louisiana</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlMassachussets}>Massachusetts</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlMinnesotaIowaSouthDakota}>Minnesota-Iowa-South Dakota</a> &nbsp;&nbsp;&nbsp;
            </div>

          </div>

          <div style={{ marginTop: 10 }} className="col-sm-6 col-xs-12 col-md-3">
            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlMississipi}>Mississipi</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlNevada}>Nevada </a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={ulrNewJersey}>New Jersery</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlNewYork}>New York</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlNorthCarolina}>North Carolina</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlOhio}>Ohio</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlOklahoma}>Oklahoma</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlPennsylvania}>Pennsylvania</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlPuertoRico}>Puerto Rico</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={ulrRhodeIsland}>Rhode Island</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlSouthCarolina}>South Carolina</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlUtah}>Utah-Idaho-Wyoming</a> &nbsp;&nbsp;&nbsp;
            </div>

            <div className="row text-center">
              <a style={{ fontSize: 'medium' }} target="_blank" href={urlWashington}>Washington</a> &nbsp;&nbsp;&nbsp;
            </div>


          </div>
        </div>
      </section>
    )
  }

})


module.exports = SectionEmployment



// WEBPACK FOOTER //
// ./js/sectionEmployment.js